
import { defineComponent } from 'vue'
import Text from './common/Text.vue'

export default defineComponent({
  components: {
    Text,
  },
  data() {
    return {
      demo: '',
    }
  },
  computed: {
    currentLanguage(): string {
      return this.$store.getters.getAppLanguage
    },
    formattedHeader() {
      return this.$t('home.weight.header').replace(/\n/g, '<br>')
    },
    formattedDesc() {
      return this.$t('home.weight.desc').replace(/\n/g, '<br>')
    },
  },
  watch: {
    currentLanguage(newLang) {
      this.updateMediaSources(newLang)
    },
  },
  methods: {
    updateMediaSources(lang: string) {
      const assetLang = lang === 'jp' ? 'ja' : lang
      try {
        this.demo = require(`@/assets/pages/home/screens/demo3-weight-${assetLang}.png`)
      } catch (e) {
        this.demo = require('@/assets/pages/home/screens/demo3-weight-en.png')
      }
    },
  },
  created() {
    this.updateMediaSources(this.currentLanguage)
  },
})
